import queryString from 'query-string'

export const triggerHubbleTracking = async (eventType: string, data: any) => {
  fetch(
    `${
      process.env.NEXT_PUBLIC_API_HUBBLE_URL
    }${eventType}?${queryString.stringify(data)}`,
  )
}
